module.exports = __webpack_public_path__ + "img/bk_19_04.01a020ce.png";